module.exports = __webpack_public_path__ + "assets/img/file@2x.c192212d.png";